document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-primary-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
  }

  if (menuToggle && nav) {
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          menuToggle.setAttribute('aria-expanded', 'false');
          nav.classList.remove('is-open');
          document.body.classList.remove('menu-open');
        }
      });
    });
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((el) => el.classList.remove('is-active'));
      gallery.querySelectorAll('[data-gallery-media]').forEach((el) => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const target = gallery.querySelector(`[data-gallery-media="${thumb.dataset.galleryThumb}"]`);
      if (target) target.classList.add('is-active');
    });
  });

  const checkedBoatFilter = document.querySelector('input[type="checkbox"][name*="modele_bateau_amorceurs"]:checked');
  if (checkedBoatFilter) {
    const filterLabel = checkedBoatFilter.closest('.filter-option')?.querySelector('span')?.textContent || '';
    const selectedBoat = filterLabel.replace(/\s*\(\d+\)\s*$/, '').trim();
    if (selectedBoat) {
      document.querySelectorAll('[data-product-card][data-product-handle^="support-bateau-amorceur"] [data-product-link]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('boat', selectedBoat);
        link.href = url.toString();
      });
    }
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const section = select.closest('[data-product-section]');
    if (!section) return;

    const highVariant = section.dataset.highVariant === 'true';
    const radios = Array.from(section.querySelectorAll('[data-option-value]'));

    const syncOptionLabels = () => {
      section.querySelectorAll('[data-option-position]').forEach((block) => {
        const checked = block.querySelector('[data-option-value]:checked');
        const label = block.querySelector('[data-selected-option]');
        const property = block.querySelector('[data-option-property]');
        if (checked && label) label.textContent = checked.value;
        if (checked && property) property.value = checked.value;
      });
    };

    if (highVariant) {
      const currentUrl = new URL(window.location.href);
      const isMonocoqueSpreader = (section.dataset.productUrl || '').includes('/products/disperseur-mecanique-monocoque');
      if (isMonocoqueSpreader && !currentUrl.searchParams.has('option_values') && !currentUrl.searchParams.has('variant')) {
        const camouflageBlock = Array.from(section.querySelectorAll('[data-option-position]')).find((block) => {
          const title = block.querySelector('.product-option-block__title span')?.textContent?.trim().toLowerCase() || '';
          return title.includes('camou');
        });
        const nonRadio = camouflageBlock ? Array.from(camouflageBlock.querySelectorAll('[data-option-value]')).find((radio) => radio.value.trim().toLowerCase() === 'non') : null;
        if (nonRadio && !nonRadio.checked) {
          nonRadio.checked = true;
          const selectedIds = Array.from(section.querySelectorAll('[data-option-value]:checked'))
            .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
            .map((input) => input.dataset.optionValueId)
            .filter(Boolean);
          if (selectedIds.length) {
            const url = new URL(section.dataset.productUrl || window.location.pathname, window.location.origin);
            url.searchParams.set('option_values', selectedIds.join(','));
            window.location.replace(url.toString());
            return;
          }
        }
      }

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          syncOptionLabels();
          const selectedIds = Array.from(section.querySelectorAll('[data-option-value]:checked'))
            .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
            .map((input) => input.dataset.optionValueId)
            .filter(Boolean);

          if (!selectedIds.length) return;

          const url = new URL(section.dataset.productUrl || window.location.pathname, window.location.origin);
          url.searchParams.set('option_values', selectedIds.join(','));

          const boat = new URL(window.location.href).searchParams.get('boat');
          if (boat) url.searchParams.set('boat', boat);

          window.location.assign(url.toString());
        });
      });
      syncOptionLabels();
      return;
    }

    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const installments = section.querySelector('[data-product-installments]');
    const button = section.querySelector('[data-add-to-cart]');
    const variantsNode = section.querySelector('[data-product-variants]');
    let variants = [];
    if (variantsNode) {
      try { variants = JSON.parse(variantsNode.textContent); } catch (e) { variants = []; }
    }

    const selectedOptions = () => {
      const groups = {};
      radios.forEach((radio) => { if (radio.checked) groups[Number(radio.dataset.optionIndex)] = radio.value; });
      return Object.keys(groups).sort((a,b) => Number(a)-Number(b)).map((key) => groups[key]);
    };

    const refreshAvailability = () => {
      if (!variants.length) return;
      radios.forEach((radio) => {
        const idx = Number(radio.dataset.optionIndex);
        const current = selectedOptions();
        const possible = variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((value, variantIdx) => {
            if (variantIdx === idx) return value === radio.value;
            return !current[variantIdx] || current[variantIdx] === value;
          });
        });
        radio.closest('.product-option-pill')?.classList.toggle('is-unavailable', !possible);
      });
    };

    const update = () => {
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (compare) compare.innerHTML = opt.dataset.compare ? `<s>${opt.dataset.compare}</s>` : '';
      if (installments) installments.classList.toggle('is-hidden', Number(opt.dataset.priceCents || 0) < 10000);
      const available = opt.dataset.available === 'true';
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
      }
      syncOptionLabels();
      refreshAvailability();
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        history.replaceState({}, '', url.toString());
      }
    };

    const resolveVariantFromRadios = () => {
      if (!variants.length) return;
      const chosen = selectedOptions();
      const variant = variants.find((candidate) => candidate.options.length === chosen.length && candidate.options.every((value, idx) => value === chosen[idx]));
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'COMBINAISON INDISPONIBLE'; }
        syncOptionLabels();
        refreshAvailability();
        return;
      }
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const boatSelect = section.querySelector('[data-boat-model]');
    if (boatSelect) {
      const boatLabel = section.querySelector('[data-selected-boat]');
      const boatHelp = section.querySelector('[data-boat-size-help]');
      boatSelect.addEventListener('change', () => {
        const boatOption = boatSelect.options[boatSelect.selectedIndex];
        const recommendedSize = boatOption?.dataset.recommendedSize || '';
        if (boatLabel) boatLabel.textContent = boatOption?.textContent || 'Choisissez votre bateau';
        if (boatHelp) boatHelp.textContent = recommendedSize ? `Taille ${recommendedSize} présélectionnée pour ce modèle.` : '';
        if (!recommendedSize) return;

        const sizeRadio = radios.find((radio) => {
          const block = radio.closest('[data-option-position]');
          const title = block?.querySelector('.product-option-block__title span')?.textContent?.trim().toLowerCase() || '';
          return title.includes('taille') && radio.value.trim().toUpperCase().startsWith(recommendedSize);
        });
        if (sizeRadio && !sizeRadio.disabled) {
          sizeRadio.checked = true;
          sizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    radios.forEach((radio) => radio.addEventListener('change', resolveVariantFromRadios));
    select.addEventListener('change', update);
    update();

    if (boatSelect) {
      const requestedBoat = new URL(window.location.href).searchParams.get('boat');
      if (requestedBoat) {
        const normalizedBoat = requestedBoat.trim().toLowerCase();
        const matchingOption = Array.from(boatSelect.options).find((option) =>
          option.value && option.textContent.trim().toLowerCase() === normalizedBoat
        );
        if (matchingOption) {
          boatSelect.value = matchingOption.value;
          boatSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });

  document.querySelectorAll('#CollectionFiltersForm').forEach((form) => {
    let priceTimer;

    const submitFilters = () => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    };

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', submitFilters);
    });

    form.querySelectorAll('input[type="number"]').forEach((input) => {
      input.addEventListener('input', () => {
        window.clearTimeout(priceTimer);
        priceTimer = window.setTimeout(submitFilters, 650);
      });
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = document.getElementById(select.getAttribute('form'));
      if (!form) return;
      const hidden = form.querySelector('input[name="sort_by"]');
      if (hidden) hidden.value = select.value;
      form.submit();
    });
  });

  document.querySelectorAll('[data-filter-toggle]').forEach((button) => {
    button.addEventListener('click', () => document.body.classList.toggle('filters-open'));
  });
});
